import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ctv-web-next/ctv-web-next/src/app/[locale]/features/_components/FeaturesContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ctv-web-next/ctv-web-next/src/mobile/home/pre-login/ursula/features/Features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ctv-web-next/ctv-web-next/src/shared/hocs/hoc-client-component/WithLocationHistory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ctv-web-next/ctv-web-next/src/shared/hocs/hoc-client-component/WithMwebPageCheck.tsx");
